import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { delayRender } from 'helpers/decorators'
import styles from './card-loader.styl'

const CardLoader = ({ logs }) => (
  <div className={cx(styles.wrap, { [styles.logs]: logs })}>
    <div className={styles.loader}>
      <div className={styles.avatar} />
      <div className={styles.line} />
      <div className={styles.paragraph} />
    </div>
    <div className={styles.loader}>
      <div className={styles.avatar} />
      <div className={styles.line} />
      <div className={styles.paragraph} />
    </div>
    <div className={styles.loader}>
      <div className={styles.avatar} />
      <div className={styles.line} />
      <div className={styles.paragraph} />
    </div>
    {logs && (
      <div className={styles.loader}>
        <div className={styles.avatar} />
        <div className={styles.line} />
        <div className={styles.paragraph} />
      </div>
    )}
  </div>
)

CardLoader.propTypes = {
  logs: PropTypes.bool
}

CardLoader.defaultProps = {}

export default delayRender()(CardLoader)
